export const environment = {
    baseUrl: '/',
    api_base_url: 'https://gateway-stage.optum.com/',
    sso_invite_path: 'api/non-prod/clin/careco/pathway/admin/1.0',
    redirectUri: 'https://pw-admin-invite-nonprod.optum.com/sso?id=',
    post_logout_redirect_uri: 'https://pw-admin-invite-nonprod.optum.com/sso',
    issuer: 'https://identity.nonprod.onehealthcareid.com/oidc/authorize',
    logoutUri: 'https://identity.nonprod.onehealthcareid.com/oidc/logout',
    tokenEndpoint: 'https://identity.nonprod.onehealthcareid.com/oidc/token'
}
